module.exports = __webpack_public_path__ + "img/Mastercard.0cd534ec.svg";